import{GETRAPPORTS} from "../ActionTypes/RapportTypes"
import axios from "axios"

export const getrapportwell = (params) => async (dispatch) => {
  try {
    const res = await axios.get('/api/Rapports/GetRapports', { params });
    dispatch({
      type: GETRAPPORTS,
      payload: res.data.rapports
    });
    return res.data; // Return data for promise chain
  } catch (error) {
    console.log(error);
    throw error;
  }
};
    

    
export const addRapport=(newRapport,navigate)=>async(dispatch)=>{
    
   try {
      
       await axios.post('/api/Rapports/AddRapports',newRapport,{
        headers : {
            Authorised : localStorage.getItem('token')
        }
    })

       dispatch(getrapportwell())

        alert("Votre rapport a été bien envoyé à l'administration");
        window.location.reload();
      
   } catch (error) {
       console.log(error)
   }
}